import gql from 'graphql-tag';

export default gql`
  mutation UpdateAdminRegisterAccount(
    $account_info_type: Int!
    $account_user_register_from: Int!
    $account_info_register_channel: Int
    $account_info_business_type: languageArg
    $account_user_name: String!
    $account_info_business_name: String
    $account_user_password: String
    $account_info_tax_id: String
    $account_user_phone_code: String!
    $account_user_phone_number: String!
    $driver_inv_code: String
    $line_id: String
    $reserve_phone_code: String
    $reserve_phone_number: String
    $criminal_history: String
    $id_card_number: String
    $id_card_pic: [typePathArg]
    $driver_card_pic: [typePathArg]
    $car_pic: [typePathArg]
    $license_plate_pic: [typePathArg]
    $act_pic: [typePathArg]
    $car_insurance_pic: [typePathArg]
    $book_bank_pic: [typePathArg]
    $company_certificate_pic: [typePathArg]
    $shareholder_document: [typePathArg]
    $director_id_card_pic: [typePathArg]
    $vat_registration_pic: [typePathArg]
    $company_profile_pic: [typePathArg]
    $setting_truck_service: [ID]
    $account_info_delivery_vat: Int
    $account_info_delivery_wht: Int
    $account_info_service_vat: Int
    $account_info_service_wht: Int
    $account_user_display_picture: String
    $bank_account: [accountInfoBankAccountArg]
    $account_info_address: String
    $account_info_country: String
    $account_info_province: String
    $account_info_district: String
    $account_info_subdistrict: String
    $account_info_postcode: String
    $account_info_branch: String
    $agent_trip_rate: Boolean
    $agent_trip_month_rate: Boolean
    $month_rate_contract_doc: String
    $month_rate_contract_date_start: String
    $month_rate_contract_date_end: String
  ) {
    adminRegisterAccount(
      account_info_type: $account_info_type
      account_user_display_picture: $account_user_display_picture
      account_user_register_from: $account_user_register_from
      account_info_register_channel: $account_info_register_channel
      account_info_business_type: $account_info_business_type
      account_user_name: $account_user_name
      account_info_business_name: $account_info_business_name
      account_user_password: $account_user_password
      account_info_tax_id: $account_info_tax_id
      account_user_phone_code: $account_user_phone_code
      account_user_phone_number: $account_user_phone_number
      driver_inv_code: $driver_inv_code
      line_id: $line_id
      reserve_phone_code: $reserve_phone_code
      reserve_phone_number: $reserve_phone_number
      criminal_history: $criminal_history
      id_card_number: $id_card_number
      id_card_pic: $id_card_pic
      driver_card_pic: $driver_card_pic
      car_pic: $car_pic
      license_plate_pic: $license_plate_pic
      act_pic: $act_pic
      car_insurance_pic: $car_insurance_pic
      book_bank_pic: $book_bank_pic
      company_certificate_pic: $company_certificate_pic
      shareholder_document: $shareholder_document
      director_id_card_pic: $director_id_card_pic
      vat_registration_pic: $vat_registration_pic
      company_profile_pic: $company_profile_pic
      setting_truck_service: $setting_truck_service
      account_info_delivery_vat: $account_info_delivery_vat
      account_info_delivery_wht: $account_info_delivery_wht
      account_info_service_vat: $account_info_service_vat
      account_info_service_wht: $account_info_service_wht
      bank_account: $bank_account
      account_info_address: $account_info_address
      account_info_country: $account_info_country
      account_info_province: $account_info_province
      account_info_district: $account_info_district
      account_info_subdistrict: $account_info_subdistrict
      account_info_postcode: $account_info_postcode
      account_info_branch: $account_info_branch
      agent_trip_rate: $agent_trip_rate
      agent_trip_month_rate: $agent_trip_month_rate
      month_rate_contract_doc: $month_rate_contract_doc
      month_rate_contract_date_start: $month_rate_contract_date_start
      month_rate_contract_date_end: $month_rate_contract_date_end
    ) {
      account_info_id
      account_user_id
      account_token_key
    }
  }
`;
